export default __webpack_public_path__ + "static/media/call.0fb17c89.wav";